import React, { useState } from "react";
import { LogIn, Mail, Menu, X } from "lucide-react";
import { Button } from "./ui/button";

export const MobileNav = ({ onSignIn, onContact }) => {
  const [open, setOpen] = useState(false);
  const go = (fn) => () => { setOpen(false); fn(); };
  return (
    <div className="sm:hidden shrink-0">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        data-testid="mobile-menu-toggle"
        aria-label={open ? "Close menu" : "Open menu"}
        aria-expanded={open}
        className="h-11 w-11 inline-flex items-center justify-center rounded-full border-2 border-cyan-500 text-cyan-600 hover:bg-cyan-50 transition-colors"
      >
        {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
      </button>
      <div
        data-testid="mobile-menu-panel"
        className={`absolute left-0 right-0 top-full z-40 bg-white border-b-2 border-gray-200 shadow-lg px-6 overflow-hidden transition-[max-height,opacity,padding] duration-300 ease-out ${
          open ? "max-h-60 opacity-100 py-4" : "max-h-0 opacity-0 py-0 pointer-events-none invisible"
        }`}
      >
        <div className="flex flex-col gap-3">
          <Button
            onClick={go(onSignIn)}
            data-testid="mobile-signin-btn"
            className="w-full bg-gradient-to-r from-cyan-500 to-cyan-600 hover:from-cyan-600 hover:to-cyan-700 text-white rounded-full py-3 font-semibold"
          >
            <LogIn className="w-4 h-4 mr-2" />
            Sign In
          </Button>
          <Button
            onClick={go(onContact)}
            data-testid="mobile-contact-btn"
            variant="outline"
            className="w-full border-2 border-cyan-500 text-cyan-600 hover:bg-cyan-50 rounded-full py-3 font-semibold"
          >
            <Mail className="w-4 h-4 mr-2" />
            Contact Us
          </Button>
        </div>
      </div>
    </div>
  );
};
